import React from "react"
import { BIO_TEXT } from "./Bio"
import "./About.css"

export const About = ({ photo, id }) => (
    <section className="lf-about" id={id}>
        <div className="lf-about__photo" style={{ backgroundImage: `url(${photo})` }}></div>
        <div className="lf-about__copy">
            <div className="lf-wrap">
                <div className="lf-about__inner">
                    <div className="lf-eyebrow">The band</div>
                    <h2>Chaos &amp;<br />Soothe.</h2>
                    <p>{BIO_TEXT}</p>
                </div>
            </div>
        </div>
    </section>
)
